import { Component } from '@angular/core';

@Component({
  selector: 'fts-compact-header-overlay',
  templateUrl: './compact-header-overlay.component.html',
  styleUrls: ['./compact-header-overlay.component.scss'],
})
export class CompactHeaderOverlayComponent {}
